import React, { useEffect, useState } from 'react';
import {
  intialPageSize,
  validDateField,
  validEndDateField,
  validStartDateField,
  spedNoteArchiveSuccess,
  spedNoteUnArchiveSuccess,
} from 'constants';
import {
  onSave,
  emptyFunction,
  getOptionLabel,
  useNotification,
  getButtonSpinner,
  showBackdropLoader,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import * as yup from 'yup';
import { format } from 'date-fns';
import {
  studentSpedNotesColumns,
  getStudentSpedNotesListData,
} from './getSpedStudentsListData';
import {
  getAllSpedNotes,
  getStudentSpedNote,
  getStudentSpedNotes,
  postSpedNoteArchive,
  postSpedNoteUnArchive,
  getSpedNotesFilterOptions,
} from '../../services/spedNotesApi';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import AddSpedNote from './AddSpedNote';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import SpedNoteDialog from './SpedNoteDialog';
import { GridForm } from 'components/Ui/styled';
import {
  setIsNewSpedNote,
  setSingleSpedNote,
  setSelectedStudents,
} from '../../store/spedNotesSlice/spedNoteSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { BulkSignOffHeader } from './BulkSIgnOff/bulkSignOffUtils';
import { FormInputDate } from 'components/Common/Forms/FormInputDate';
import BulkSignOffComponent from './BulkSIgnOff/BulkSignOffComponent';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import { getSearchedStudents } from 'layouts/students/service/studentsApi';
import { FormInputAutoCompleteSearch } from 'components/Common/Forms/FormAutoCompleteSearch';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const schema = yup.object({
  startDate: yup
    .date()
    .nullable()
    .typeError(validDateField)
    .test('is-before-endDate', validStartDateField, function (value) {
      const { endDate } = this.parent;
      if (!value || !endDate) return true;
      return value <= endDate;
    }),

  endDate: yup
    .date()
    .nullable()
    .typeError(validDateField)
    .min(yup.ref('startDate'), validEndDateField),
});

const InputBySTudentTab = () => {
  const {
    NotificationPopup,
    setOpenNotification,
    handleErrorResponse,
    setNotificationMessage,
  } = useNotification();

  const dispatch = useDispatch();
  const canArchivepedNotes = usePermissionCustomHook('CAN_ARCHIVE_SPED_NOTES');
  const canSignOffSpedNotes = usePermissionCustomHook('CAN_SIGNOFF_SPED_NOTES');

  const [studentSpedNotesListData, setStudentSpedNotesListData] = useState({
    rows: [],
    isLoading: false,
    pageSize: intialPageSize,
  });

  const [endDate, setEndDate] = useState(null);
  const [student, setStudent] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [spedNoteForm, setSpedNoteForm] = useState({});
  const [bulkSignOff, setBulkSignOff] = useState(false);
  const [studentOptions, setStudentOptions] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [filterOptions, setfilterOptionss] = useState(null);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [studentSearchQuery, setStudentSearchQuery] = useState('');
  const [openSingleNewSpedNote, setOpenSingleNewSpedNote] = useState(false);
  const [isStudentSearchLoading, setIsStudentSearchLoading] = useState(false);

  const defaultValue = {
    startDate: startDate,
    endDate: endDate,
    archivedNotes: false,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });

  const { handleSubmit, control, register, formState, setValue, watch } =
    useFunction;
  const { errors } = formState;

  const watchedStartDate = watch('startDate');
  const watchedEndDate = watch('endDate');
  const watchedArchivedNotes = watch('archivedNotes');

  // useEffect(() => {
  //   if (studentSearchQuery?.length >= 1) fetchSearchedStudents();
  // }, [studentSearchQuery]);

  useEffect(() => {
    getFilterOptions();
    // fetchAllSpedNotes();
  }, []);

  // useEffect(() => {
  //   dispatch(setSelectedStudents([]));
  // }, []);

  // // Auto-fetch when student or dates change
  // useEffect(() => {
  //   if (!isInitialLoad) {
  //     if (student) {
  //       fetchStudentSpedNotes();
  //     } else {
  //       fetchAllSpedNotes();
  //     }
  //   }
  // }, [student, watchedStartDate, watchedEndDate, watchedArchivedNotes]);

  const getFilterOptions = async () => {
    try {
      const filterOptions = await getSpedNotesFilterOptions();
      setfilterOptionss(filterOptions);
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const fetchSearchedStudents = async () => {
    try {
      setIsStudentSearchLoading(true);
      const searchedStudents = await getSearchedStudents(
        studentSearchQuery,
        true,
        false,
        20,
      );
      setStudentOptions(searchedStudents?.items || []);
      setIsStudentSearchLoading(false);
    } catch (error) {
      setIsStudentSearchLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return null;
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    return format(parsedDate, 'yyyy-MM-dd');
  };

  const fetchAllSpedNotes = async () => {
    const endDateFormatted = formatDate(watchedEndDate);
    const startDateFormatted = formatDate(watchedStartDate);

    try {
      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: true,
      }));

      const spedNotesData = await getAllSpedNotes(
        startDateFormatted,
        endDateFormatted,
        watchedArchivedNotes,
      );

      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: false,
        rows: getStudentSpedNotesListData(spedNotesData),
      }));
      setIsInitialLoad(false);
    } catch (error) {
      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: false,
      }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const fetchStudentSpedNotes = async () => {
    const endDateFormatted = formatDate(watchedEndDate);
    const startDateFormatted = formatDate(watchedStartDate);
    const studentId = student?.id || student?.studentId || null;

    if (!studentId) return;

    try {
      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: true,
      }));

      const spedNotesData = await getStudentSpedNotes(
        startDateFormatted,
        endDateFormatted,
        studentId,
        watchedArchivedNotes,
      );

      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: false,
        rows: getStudentSpedNotesListData(spedNotesData),
      }));
      setIsInitialLoad(false);
    } catch (error) {
      setStudentSpedNotesListData((prev) => ({
        ...prev,
        isLoading: false,
      }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  // Keep the manual fetch function for the button
  const handleManualFetch = () => {
    if (student) {
      fetchStudentSpedNotes();
    } else {
      fetchAllSpedNotes();
    }
  };

  const pageSizeChange = pageSizeChangeHandler(setStudentSpedNotesListData);

  const handleEdit = async (params) => {
    const { id } = params?.row;
    try {
      setIsFormLoading(true);
      const getData = await getStudentSpedNote(id);
      setSpedNoteForm(getData);
      setOpenSingleNewSpedNote(true);
      dispatch(setIsNewSpedNote(false));
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleArchive = (params) => {
    const { row } = params;
    onSave(
      spedNoteArchiveSuccess,
      true,
      postSpedNoteArchive,
      emptyFunction,
      row.id,
      '',
      handleManualFetch,
      emptyFunction,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setArchiveLoading,
      archiveLoading,
    );
  };

  const handleUnArchive = (params) => {
    const { row } = params;
    onSave(
      spedNoteUnArchiveSuccess,
      true,
      postSpedNoteUnArchive,
      emptyFunction,
      row.id,
      '',
      handleManualFetch,
      emptyFunction,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setArchiveLoading,
      archiveLoading,
    );
  };

  const handleNewSingleSpedNote = () => {
    setOpenSingleNewSpedNote(true);
    dispatch(setSingleSpedNote(true));
  };

  const handleBulkSignOff = () => {
    setBulkSignOff(true);
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <MDBox mb={2}></MDBox>
      {canSignOffSpedNotes && (
        <BulkSignOffHeader
          bulkSignOff={bulkSignOff}
          setBulkSignOff={setBulkSignOff}
          handleBulkSignOff={handleBulkSignOff}
        />
      )}
      {/* <GridForm container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FormInputAutoCompleteSearch
            value={student}
            options={studentOptions}
            getOptionLabel={getOptionLabel}
            placeholder="Enter name or ID..."
            label="Search for student by name or ID"
            isSearchloading={isStudentSearchLoading}
            setInputSearchQuery={setStudentSearchQuery}
            setSelectedInput={(val) => {
              setStudent(val);
              setValue('student_id', val?.studentId || '', {
                shouldValidate: true,
                shouldDirty: true,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputDate
            value=""
            name="startDate"
            control={control}
            label="Start date"
            maxDate={watchedEndDate}
            errors={!!errors.startDate}
            helperText={errors?.startDate?.message}
            register={register('startDate')}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputDate
            value=""
            name="endDate"
            label="End date"
            control={control}
            minDate={watchedStartDate}
            errors={!!errors.endDate}
            helperText={errors?.endDate?.message}
            register={register('endDate')}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormInputSwitch
            control={control}
            name="archivedNotes"
            label="Archived Notes"
            checked={defaultValue?.archivedNotes}
          />
        </Grid>
        <Grid item xs={12} sm={4}></Grid>
        <Grid container item xs={12} sm={4} justifyContent="end">
          {getButtonSpinner(false, handleNewSingleSpedNote, 'New SPED Note')}
        </Grid>
      </GridForm>
       <DeltaDataGrid
        setListData={pageSizeChange}
        listData={studentSpedNotesListData}
        columns={studentSpedNotesColumns(
          handleEdit,
          handleArchive,
          handleUnArchive,
          canArchivepedNotes
        )}
      /> 
       <SpedNoteDialog
        selectedStudent={student}
        spedNoteForm={spedNoteForm}
        open={openSingleNewSpedNote}
        filterOptions={filterOptions}
        setSpedNoteForm={setSpedNoteForm}
        fetchSpedNotes={handleManualFetch}
        setOpen={setOpenSingleNewSpedNote}
        isSingleStudent={openSingleNewSpedNote}
        /> */}
      {!bulkSignOff && <AddSpedNote filterOptions={filterOptions} />}
      {bulkSignOff && <BulkSignOffComponent setBulkSignOff={setBulkSignOff} />}
      <NotificationPopup />
    </>
  );
};

export default InputBySTudentTab;
